import type { ChangeEvent, MouseEvent } from "react"
import React, { useState } from "react"
import axios, { AxiosError } from "axios"
import "./cta.scss"

// TODO: Leverage Card component
export const CallToAction = () => (
  <div className="cta">
    <div className="cta-green-square" />
    <div className="cta-yellow-square" />
    <div className="cta-orange-square" />
    <div className="cta-purple-square" />
    <div className="max-w-sm rounded overflow-hidden shadow-lg cta-card">
      <h3>Get Updates Delivered to Your Inbox</h3>
      <FormContent />
    </div>
  </div>
)

const FormContent = () => {
  const [email, setEmail] = useState(``)
  const [isSubscribed, setIsSubscribed] = useState(false)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const subscribe = async (event: MouseEvent<HTMLButtonElement>) => {
    const data = {
      fields: [{ name: `email`, value: email }],
    }
    const portalId = `8186536`
    const formId = `b61423e5-1949-4ebc-965d-63c1c7fb723e`
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`

    try {
      await axios({
        method: `post`,
        url,
        data,
        headers: {
          "Content-Type": `application/json`,
        },
      })

      setEmail(``)
      setIsSubscribed(true)
    } catch (err: Error | AxiosError) {
      const errorType = err.response?.data?.errors[0].errorType
      switch (errorType) {
        case `INVALID_EMAIL`:
          alert(`Please enter a valid email.`)
          break
        case `REQUIRED_FIELD`:
          alert(`Please enter your email.`)
          break
        default:
          alert(`Unknown error, please try again.`)
      }
    }
  }

  if (isSubscribed) {
    return (
      <p className="subscribed-text">Thanks for signing up to get updates!</p>
    )
  }

  return (
    <div className="input-button-group">
      <input
        value={email}
        onChange={handleChange}
        placeholder="Email Address"
      />
      <button onClick={subscribe}>Subscribe</button>
    </div>
  )
}
